module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-1.7381f8bf.svg";